/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

@Component({
  standalone: false,
  selector: 'adn-mime-type',
  template: `{{ (mimeType | mimeTypeKey) | ogTranslate }}`
})
export class MimeTypeOutputComponent {
  @Input() mimeType: string;
}
